if(typeof FN == 'undefined') FN = {};

FN.store = {
  config: {
    selectors: {
      formID: 'buy-form',
      seatsContainerClass: 'seats',
      validationContainerClass: 'validation-message',
      quantityContainerClass: 'seats__sentence--part__amount',
      quantityInput: 'input.seats__amount',
      quantityStepperUpClass: 'stepper-controls__up',
      quantityStepperDownClass: 'stepper-controls__down',
      billingSecondaryToggleClass: 'toggle--billing-secondary',
      couponInputToggleClass: 'toggle--coupon',
      upgradeInputToggleClass: 'toggle--upgrade',
      billingPrimaryClass: 'billing--primary',
      billingSecondaryClass: 'billing--secondary',
      couponContainerClass: 'discounts__coupon',
      couponInput: 'input[name="coupon_code"]',
      upgradeContainerClass: 'discounts__upgrade',
      upgradeInput: 'input[name="upgrade_license_code"]',
      userLabelClass: 'seats__sentence--part__users',
      unitPriceRegularClass: 'unit-price--regular',
      unitPriceRegularAmountClass: 'unit-price--regular__amount',
      unitPriceMonthlyRegularAmountClass: 'unit-price-monthly--regular__amount',
      unitPriceStrikethroughClass: 'unit-price--regular__strikethrough',
      unitPriceDiscountedClass: 'unit-price--discounted',
      unitPriceMonthlyDiscountedClass: 'unit-price-monthly--discounted',
      unitPriceInvalidClass: 'unit-price--invalid',
      totalPriceClass: 'total-price__value',
      totalPriceMonthlyClass: 'total-price-monthly__value',
      discountPopoverClass: 'seats__discount',
      discountPopoverHeadlineClass: 'popover__headline-main',
      discountPopoverHeadlineSuffixClass: 'popover__headline-suffix',
      discountPopoverSublineClass: 'popover__subline',
      discountPopoverInfoTextClass: 'popover__infotext',
      discountPopoverInfoTextIndicatorClass: 'popover__infotext-indicator',
      billingFieldEmail: 'input[name="email"]',
      billingFieldCountry: 'select[name="country"]',
      billingFieldZip: 'input[name="zip_code"]',
      billingFieldVat: 'input[name="vat_id_number"]',
      billingFieldName: 'input[name="name"]',
      billingFieldCompany: 'input[name="company_name"]',
      billingFieldAddress: 'input[name="address"]',
      billingFieldCity: 'input[name="city"]',
      consentFieldLegal: 'input[name="legal-consent"]',
      consentFieldMarketing: 'input[name="marketing-consent"]',
      existingEmailAccountInfoClass: 'existing-account-info',
      submitButtonID: 'buy-form__submit',
      paymentMethodRadio: 'input[name="payment-method"]',
      billingEmailField: '.billing-email-field'
    },
    discountTypes: {
      volumeDiscount: 'VOLUME_DISCOUNT',
      upgradeDiscount: 'UPGRADE_DISCOUNT',
      salesDiscount: 'SALES_DISCOUNT',
      couponDiscount: 'COUPON_DISCOUNT',
      customDiscount: 'CUSTOM_DISCOUNT'
    },
    discountDurationTypes: {
      once: 'ONCE',
      repeating: 'REPEATING',
      permanent: 'PERMANENT'
    },
    errorConstants: {
      couponNotFound: 'COUPON_NOT_FOUND', 
      couponAlreadyRedeemed: 'COUPON_ALREADY_REDEEMED',
      couponNotApplicable: 'COUPON_NOT_APPLICABLE',
      couponExpired: 'COUPON_EXPIRED',
      upgradeLicenseNotFound: 'UPGRADE_LICENSE_NOT_FOUND', 
      upgradeLicenseAlreadyUpgraded: 'UPGRADE_LICENSE_ALREADY_UPGRADED', 
      upgradeLicenseNotApplicable: 'UPGRADE_LICENSE_NOT_APPLICABLE',
      finalizeCouponAlreadyRedeemed: 'COUPON_ALREADY_REDEEMED_ERROR',
      finalizeUpgradeLicenseAlreadyUpgraded: 'UPGRADE_LICENSE_ALREADY_UPGRADED_ERROR',
      finalizeCouponExpired: 'COUPON_EXPIRED_ERROR',
      finalizeSalesDiscountExpired: 'SALES_DISCOUNT_EXPIRED_ERROR'
    },
    cartStatus: {
      error: 'error',
      loading: 'loading',
      success: 'success'
    },
    messages: {
      couponSuccessfullyApplied: "Coupon code was successfully applied.",
      couponNotFound: "The specified coupon code was not found.",
      couponAlreadyRedeemed: "The specified coupon code was already redeemed.",
      couponNotApplicable: "The specified coupon code was not applicable.",
      couponRemoved: "Coupon code was removed from your order.",
      couponExpired: "The specified coupon code has expired.",
      salesDiscountExpired: "This deal has ended. Loading the current price...",
      upgradeLicenseSuccessfullyApplied: "Upgrade discount was applied - license is valid.",
      upgradeLicenseGracePeriod: "can be upgraded for free, because the original license was purchased on/after March 26, 2018. You can add more seats later, after completing this free order.",
      upgradeLicenseNotFound: "License key was not found.",
      upgradeLicenseAlreadyUpgraded: "License key was already used for an upgrade.",
      upgradeLicenseNotApplicable: "License key is not applicable.",
      upgradeLicenseNotNecessary: "License key is already valid for the latest Tower version. No upgrade necessary!",
      upgradeLicenseRemoved: "License was removed from your order.",
      generalErrorOccured: "An error occured. Please contact support.",
      couponInfoTextOneTime: "This is a one-time offer for customers new to the current Tower version.",
      couponInfoTextOnce: "The discount applies to this order. Subsequent orders (e.g. for additional seats) are priced at the selected plan's standard pricing.",
      couponInfoTextPermanent: "The discount applies to your account for an indefinite time.",
      couponInfoTextRepeating: "The discount applies to the first <periods>, after which your account renews at the selected plan's standard pricing.",
      existingEmailAccountCancelled: 'This email address is connected to an existing subscription that was cancelled. Instead of purchasing a new subscription here in our store, you can simply <a href="' + FN.siteURL('help', 'guides/account/faq/manage-account') + '">log into your account and resume it</a>.',
      existingEmailAccountExpired: 'This email address is already connected to an existing subscription that expired. Instead of purchasing a new subscription here in our store, you can simply <a href="' + FN.siteURL('help', 'guides/account/faq/manage-account') + '">log into your account and resume it</a>.',
      existingEmailAccountActive: "This email address is already connected to an active subscription.",
      existingEmailAccountAddSeatsLogIn: 'If you want to purchase <b>additional seats</b> for this subscription, <a href="' + FN.siteURL('help', 'guides/account/faq/add-seats') + '">please log into your account!</a>',
      existingEmailAccountAddSeatsGetInTouch: 'If you want to <b>add more seats</b> to this subscription, please <a href="' + FN.siteURL('tower', 'support/contact/') + '">get in touch with our support!</a>',
    }
  },  
  
  
  cart: {
    quantity: 1,
    maxQuantity: false,
    minQuantity: false,
    pricing: false,
    couponCode: false,
    upgradeLicense: false,
    requiredFields: []
  },
  
  
  init: function() {
    if($('#' + FN.store.config.selectors.formID).length != 1) return;
    if(typeof FN.checkout == 'undefined') return;

    // fill pricing + currency
    FN.store.initQuantity();
    FN.store.updateDisplayedPricing();
    FN.store.updateDisplayedMonthlyPricing();
    FN.store.updateDisplayedUserSentence();
    FN.store.initCountrySelection();
    FN.store.determineRequiredFields();

    // if URL params are present: show coupon / upgrade fields
    FN.store.initCouponField();
    FN.store.initUpgradeField();    
    
    // event handlers
    FN.store.initEventHandlers();

    // enterprise-specific setup (payment method toggle)
    if (FN.store.isEnterpriseForm()) FN.store.initEnterpriseForm();
  },

  
  /**
  * Proceed to payment overlay, after data was entered
  */
  proceedToPayment: function() {
    var cartStatus = FN.store.validateCart();
    if(cartStatus.status === FN.store.config.cartStatus.error) {
      FN.storeHelpers.displayCartStatus(cartStatus);
      return false;
    }
    
    var cartStatus = {'status': FN.store.config.cartStatus.loading, 'messages': [{'message': 'Your order is being prepared...'}] };
    FN.storeHelpers.displayCartStatus(cartStatus);
    
    FN.store.finalizeRemoteCheckout();
    FN.storeHelpers.subscribeToNewsletter();
  },
  
  
  /**
  * Determine which fields are required (depending on the current values)
  */
  determineRequiredFields: function(){
    if (FN.store.isEnterpriseForm()) return FN.store.determineRequiredFieldsEnterprise();

    var requiredFields = [];

    var currentVatInput = $(FN.store.config.selectors.billingFieldVat).val().trim();
    var currentCountrySelection = $(FN.store.config.selectors.billingFieldCountry + ' option:selected');
    var isPostalCodeRequired = ($(currentCountrySelection).data('needs-postcode') === 1) ? true : false;
    var isVatFilled = (currentVatInput.length > 0) ? true : false;
    
    requiredFields.push(FN.store.config.selectors.billingFieldEmail);
    requiredFields.push(FN.store.config.selectors.billingFieldCountry);
    if(isPostalCodeRequired || isVatFilled) requiredFields.push(FN.store.config.selectors.billingFieldZip);
    if(isVatFilled) requiredFields.push(FN.store.config.selectors.billingFieldCompany);
    if(isVatFilled) requiredFields.push(FN.store.config.selectors.billingFieldAddress);
    if(isVatFilled) requiredFields.push(FN.store.config.selectors.billingFieldCity);
    
    FN.store.cart.requiredFields = requiredFields;
    FN.storeHelpers.highlightRequiredFields();
    
    return requiredFields;
  },
  
  
  /**
  * Validate the order before finalizing / submitting it
  */
  validateCart: function() {
    var cartStatus = {'status': false, 'messages': [] };
    FN.store.determineRequiredFields();
    
    //---------- check required fields
    for(var i=0; i<FN.store.cart.requiredFields.length; i++){
      var fieldValidation = FN.storeHelpers.validateField(FN.store.cart.requiredFields[i]);
      if(fieldValidation){
        cartStatus.messages.push(fieldValidation);
      }
    }
    
    //---------- check legal + marketing consent
    if(!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.consentFieldLegal).prop('checked')) {
      cartStatus.messages.push({  'message': 'Please read and accept our Privacy Policy.', 
                                  'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.consentFieldLegal) });
    }
    if($('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.consentFieldMarketing + ':checked').length !== 1) {
      cartStatus.messages.push({  'message': 'Please tell us if you want to hear about news & updates.', 
                                  'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.consentFieldMarketing) });
    }

    //---------- check quantity
    if(isNaN(FN.store.cart.quantity) || FN.store.cart.quantity < 0) {
      cartStatus.messages.push({  'message': 'Please choose how many seats you want to purchase.', 
                                  'fieldSelector': FN.store.config.selectors.quantityInput});
    }
    
    //---------- check privacy / ad blocker
    if(typeof Paddle == 'undefined') {
      cartStatus.messages.push({  'message': 'Our payment gateway could not be loaded. Please try reloading the page and check any ad blockers / privacy browser extensions.', 
                                  'fieldSelector': false });
    }
        
    if(cartStatus.messages.length == 0) {
      cartStatus.status = FN.store.config.cartStatus.success;
    }else{
      cartStatus.status = FN.store.config.cartStatus.error;
    }

    return cartStatus;
  },
  
  
  /**
  * Display the status of the cart (above the "Proceed to Payment" button), esp. for validation errors / missing required fields etc.
  */
  displayCartStatus: function(cartStatus) {
    var messageContainer = $('.' + FN.store.config.selectors.validationContainerClass);
    var messageHtml = '';
    for(var i=0; i<cartStatus.messages.length; i++){
      messageHtml += '<p>'+ cartStatus.messages[i].message +'</p>';
    }

    $(messageContainer).html(messageHtml).removeClass('success error loading').addClass(cartStatus.status);
    if(cartStatus.messages.length == 0){
      $(messageContainer).hide();
    }else{
      $(messageContainer).show();
    }
  },
  
  
  /**
  * Update the displayed pricing, including unit prices, discounted prices and discount popup
  */
  updateDisplayedPricing: function() {
    var unitPriceRegular = 0,
        unitPriceDiscounted = 0,
        totalPrice = 0,
        discountText = {'headline': '', 'subline': ''};
    
    // find applicable price tier for the current quantity
    FN.store.cart.pricing = FN.store.getApplicablePricing();

    // sales specials / discounts at the moment?
    if(FN.checkout.checkout_type === 'custom_order'){
      // use the set price from backend 'checkout' object (instead of calculating the price here)
      totalPrice = FN.storeHelpers.formatCurrency(FN.checkout['total_price'].toFixed(2), FN.checkout['currency']);
    
    }else if(FN.store.cart.pricing['applied_discount']) {
      unitPriceRegular = FN.storeHelpers.formatCurrency(FN.store.cart.pricing['regular_unit_price'], FN.store.cart.pricing['currency']);
      unitPriceDiscounted = FN.storeHelpers.formatCurrency(FN.store.cart.pricing['discounted_unit_price'], FN.store.cart.pricing['currency']);
      totalPrice = FN.storeHelpers.formatCurrency((FN.store.cart.pricing['discounted_unit_price'] * FN.store.cart.quantity).toFixed(2), FN.store.cart.pricing['currency']);
      
    }else{
      unitPriceRegular = FN.storeHelpers.formatCurrency(FN.store.cart.pricing['regular_unit_price'], FN.store.cart.pricing['currency']);
      unitPriceDiscounted = false;
      totalPrice = FN.storeHelpers.formatCurrency((FN.store.cart.pricing['regular_unit_price'] * FN.store.cart.quantity).toFixed(2), FN.store.cart.pricing['currency']);
    }

    $('.' + FN.store.config.selectors.unitPriceDiscountedClass).html(unitPriceDiscounted);
    $('.' + FN.store.config.selectors.unitPriceRegularAmountClass).html(unitPriceRegular);
    $('.' + FN.store.config.selectors.totalPriceClass).html(totalPrice);
    
    if(FN.store.cart.pricing['applied_discount']) {
      FN.store.showDiscount(true);
    }else{
      FN.store.showDiscount(false);
    }
  },

  /**
  * Update the displayed pricing, including unit prices, discounted prices and discount popup
  */
  updateDisplayedMonthlyPricing: function() {
    var unitPriceRegular = 0,
        unitPriceDiscounted = 0,
        totalPrice = 0,
        discountText = {'headline': '', 'subline': ''};
    
    // find applicable price tier for the current quantity
    FN.store.cart.pricing = FN.store.getApplicablePricing();

    // sales specials / discounts at the moment?
    if(FN.checkout.checkout_type === 'custom_order'){
      // use the set price from backend 'checkout' object (instead of calculating the price here)
      totalPrice = FN.storeHelpers.formatCurrency(FN.checkout['total_price'] / 12 .toFixed(2), FN.checkout['currency']);
    
    }else if(FN.store.cart.pricing['applied_discount']) {
      unitPriceRegular = FN.storeHelpers.formatCurrency(FN.store.cart.pricing['regular_unit_price'] / 12, FN.store.cart.pricing['currency']);
      unitPriceDiscounted = FN.storeHelpers.formatCurrency(FN.store.cart.pricing['discounted_unit_price'] / 12, FN.store.cart.pricing['currency']);
      totalPrice = FN.storeHelpers.formatCurrency((FN.store.cart.pricing['discounted_unit_price'] / 12 * FN.store.cart.quantity).toFixed(2), FN.store.cart.pricing['currency']);
      
    }else{
      unitPriceRegular = FN.storeHelpers.formatCurrency(FN.store.cart.pricing['regular_unit_price'] / 12, FN.store.cart.pricing['currency']);
      unitPriceDiscounted = false;
      totalPrice = FN.storeHelpers.formatCurrency((FN.store.cart.pricing['regular_unit_price'] / 12 * FN.store.cart.quantity).toFixed(2), FN.store.cart.pricing['currency']);
    }

    $('.' + FN.store.config.selectors.unitPriceMonthlyDiscountedClass).html(unitPriceDiscounted);
    $('.' + FN.store.config.selectors.unitPriceMonthlyRegularAmountClass).html(unitPriceRegular);
    $('.' + FN.store.config.selectors.totalPriceMonthlyClass).html(totalPrice);
    
    if(FN.store.cart.pricing['applied_discount']) {
      FN.store.showDiscount(true);
    }else{
      FN.store.showDiscount(false);
    }
  },
  
  
  /**
  * Update the correct 'user' or 'users' wording
  */
  updateDisplayedUserSentence: function() {
    var userWording = '';
    if(FN.store.cart.quantity == 1) {
      userWording = 'user at&nbsp;';
    }else{
      userWording = 'users at&nbsp;';
    }
    $('.'+ FN.store.config.selectors.userLabelClass).html(userWording);
  },
  
  
  /**
  * Update the quantity amount
  */
  changeQuantity: function(changeQuantity) {
    FN.store.cart.quantity += changeQuantity;
    FN.store.validateQuantity();
    $(FN.store.config.selectors.quantityInput).val(FN.store.cart.quantity);
    FN.store.updateDisplayedPricing();
    FN.store.updateDisplayedMonthlyPricing();
    FN.store.updateDisplayedUserSentence();
  },
  
  
  /**
  * Get the quantity directly from the form
  */
  updateQuantity: function() {
    FN.store.cart.quantity = parseInt($(FN.store.config.selectors.quantityInput).val());
    FN.store.validateQuantity();
    $(FN.store.config.selectors.quantityInput).val(FN.store.cart.quantity);
    FN.store.updateDisplayedPricing();
    FN.store.updateDisplayedMonthlyPricing();
    FN.store.updateDisplayedUserSentence();
  },
  
  
  validateQuantity: function() {
    if(FN.store.cart.minQuantity && FN.store.cart.quantity < FN.store.cart.minQuantity){
      FN.store.cart.quantity = FN.store.cart.minQuantity;
    }else if(FN.store.cart.maxQuantity && FN.store.cart.quantity > FN.store.cart.maxQuantity){
      FN.store.cart.quantity = FN.store.cart.maxQuantity;
    }else if(isNaN(FN.store.cart.quantity) || FN.store.cart.quantity < 1) {
      FN.store.cart.quantity = 1;
    }
  },
  
  /**
  * Display a discounted pricing, including popup
  */
  showDiscount: function(show) {
    var discountText = FN.store.getDiscountText();
    $('.' + FN.store.config.selectors.discountPopoverHeadlineClass).html(discountText.headline);
    $('.' + FN.store.config.selectors.discountPopoverHeadlineSuffixClass).html(discountText.headlineSuffix);
    $('.' + FN.store.config.selectors.discountPopoverSublineClass).html(discountText.subline);
    $('.' + FN.store.config.selectors.discountPopoverInfoTextClass).html(discountText.infotext);
    $('.' + FN.store.config.selectors.discountPopoverInfoTextIndicatorClass).on('click', function(event){
      $('.' + FN.store.config.selectors.discountPopoverInfoTextClass).toggle();
    })
    
    if(show){
      $('.' + FN.store.config.selectors.unitPriceRegularAmountClass).addClass(FN.store.config.selectors.unitPriceInvalidClass);
      $('.' + FN.store.config.selectors.unitPriceMonthlyRegularAmountClass).addClass(FN.store.config.selectors.unitPriceInvalidClass);
      FN.store.strikeThroughRegularPrice(true);
      window.setTimeout(function(){
        FN.store.showDiscountPopup();
      }, 350);

    }else{
      $('.' + FN.store.config.selectors.unitPriceRegularAmountClass).removeClass(FN.store.config.selectors.unitPriceInvalidClass);
      $('.' + FN.store.config.selectors.unitPriceMonthlyRegularAmountClass).removeClass(FN.store.config.selectors.unitPriceInvalidClass);
      FN.store.strikeThroughRegularPrice(false);
      FN.store.hideDiscountPopup();
    }
  },
  
  
  /**
  * Display the discount popup
  */
  showDiscountPopup: function() {
    $('.'+FN.store.config.selectors.discountPopoverClass).show();
    // NOTE: it seems that using fixed values in CSS for positioning is safe enough or even safer!
    // var regularPricePosition = $('.'+FN.store.config.selectors.unitPriceRegularAmountClass).position();
    // var popoverHeight = $('.'+FN.store.config.selectors.discountPopoverClass).height() + 16;   // box height + pointer height
    // var popoverPosition = {'top': (regularPricePosition.top - popoverHeight - 12) + 'px', 'left': (regularPricePosition.left) + 'px'};
    // $('.'+FN.store.config.selectors.discountPopoverClass).css({ 'display': 'block', 'top': popoverPosition.top, 'left': popoverPosition.left });
  },
  
  
  /**
  * Hide the discount popup
  */
  hideDiscountPopup: function() {
    $('.'+FN.store.config.selectors.discountPopoverClass).hide();
  },
  
  
  /**
  * Mark the regular unit price with a strikethrough when discounted
  */
  strikeThroughRegularPrice: function(show) {
    var strikeThroughElement = $('.' + FN.store.config.selectors.unitPriceStrikethroughClass);
    if(show){
      $(strikeThroughElement).show();
    }else{
      $(strikeThroughElement).hide();
    }
  },


  /**
  * Get the correct price tier for the current quantity
  */
  getApplicablePricing: function() {
    var applicablePricing;
    var pricingTiers = FN.checkout.pricings;
    
    for(var i=0; i<pricingTiers.length; i++){
      if(FN.store.cart.quantity >= pricingTiers[i]['min_quantity']){
        applicablePricing = pricingTiers[i];
        continue;
      }else{
        break;
      }
    }
    return applicablePricing;
  },
  
  
  /**
  * Get the text for display in the discount popup
  */
  getDiscountText: function() {
    var headline,
        headlineSuffix,
        subline,
        infotext;

    if(!FN.store.cart.pricing['applied_discount']) return {'headline': '', 'subline': ''};
    
    headline = parseInt(FN.store.cart.pricing['applied_discount']['percent_off']) + '% OFF';
    
    if(FN.store.cart.pricing['applied_discount']['title']) {
      subline = FN.store.cart.pricing['applied_discount']['title'];
    }else if(FN.store.cart.pricing['applied_discount']['type'] === FN.store.config.discountTypes['volumeDiscount']) {
      subline = 'Volume Discount';
    }else if(FN.store.cart.pricing['applied_discount']['type'] === FN.store.config.discountTypes['couponDiscount']) {
      subline = 'Coupon Code';
    }else if(FN.store.cart.pricing['applied_discount']['type'] === FN.store.config.discountTypes['upgradeDiscount']) {
      if('grace_period' in FN.checkout.upgrade_license && FN.checkout.upgrade_license.grace_period === true && FN.store.cart.quantity <= FN.checkout.upgrade_license.grace_period_seats) {
        subline = 'Free Upgrade for ' + FN.checkout.upgrade_license.grace_period_seats + ' Seats';
      }else{
        subline = 'Upgrade Discount';
      }
    }else{
      subline = 'Discount';
    }
    
    if(!FN.store.cart.pricing['applied_discount']['duration_type']) {
      infotext = false;
    }else if(FN.store.cart.pricing['applied_discount']['duration_type'] == FN.store.config.discountDurationTypes['once']) {
      // one-time discount, only for this order only
      infotext = FN.store.config.messages.couponInfoTextOneTime + '<br><br>' + FN.store.config.messages.couponInfoTextOnce;
      headlineSuffix = 'your first year';
    }else if(FN.store.cart.pricing['applied_discount']['duration_type'] == FN.store.config.discountDurationTypes['repeating']) {
      // repeating discount, for a certain number of periods
      infotext = FN.store.config.messages.couponInfoTextOneTime + '<br><br>';
      if(FN.store.cart.pricing['applied_discount']['duration_in_periods'] === 1){
        infotext += FN.store.config.messages.couponInfoTextRepeating.replace(/<periods>/g, 'subscription period');
        headlineSuffix = 'your complete first year';
      }else{
        infotext += FN.store.config.messages.couponInfoTextRepeating.replace(/<periods>/g, FN.store.cart.pricing['applied_discount']['duration_in_periods'] + ' subscription periods');
        headlineSuffix = 'your first ' + FN.store.cart.pricing['applied_discount']['duration_in_periods'] + ' years';
      }
    }else if(FN.store.cart.pricing['applied_discount']['duration_type'] == FN.store.config.discountDurationTypes['permanent']) {
      // indefinite discount
      infotext = FN.store.config.messages.couponInfoTextOneTime + '<br><br>' + FN.store.config.messages.couponInfoTextPermanent;
    }
    
    if(infotext) subline += '<span class="'+ FN.store.config.selectors.discountPopoverInfoTextIndicatorClass +'"></span>';
    
    return {'headline': headline, 'headlineSuffix': headlineSuffix, 'subline': subline, 'infotext': infotext};
  },

  
  /**
  * An entered email address can already have an existing subscription / account. If that's the case, we want to 
  * inform the user (to prevent new subscription purchases that actually were meant to "add seats")
  * FN.checkout.account will then have one or multiple "subscription" items with the following data:
      status: active|cancelled|expired,
      access: owner|billing_admin|license_admin|member,    
      custom: true|false
  */
  showExistingAccountNotice: function() {
    if(!'account' in FN.checkout || !'subscriptions' in FN.checkout.account && FN.checkout.account.subscriptions.length === 0) {
      // no existing account connected to this email --> hide warning view
      $('.' + FN.store.config.selectors.existingEmailAccountInfoClass).html('').hide();
      return;
    }
    
    var infoText;
    
    for(var i=0; i<FN.checkout.account.subscriptions.length; i++){
      var subscription = FN.checkout.account.subscriptions[i];
      if(subscription['access'] === 'member') continue;
      
      if(subscription['status'] === 'active'){
        infoText = FN.store.config.messages.existingEmailAccountActive + ' ';
        infoText += (subscription['custom'] == true) ? FN.store.config.messages.existingEmailAccountAddSeatsGetInTouch : FN.store.config.messages.existingEmailAccountAddSeatsLogIn;
        break;    // after finding and mentioning an 'active' account, we don't need to inform about possible others
      }else if(subscription['status'] === 'cancelled'){
        infoText = FN.store.config.messages.existingEmailAccountCancelled;
      }else if(subscription['status'] === 'expired'){
        infoText = FN.store.config.messages.existingEmailAccountExpired;
      }
    }
    
    $('.' + FN.store.config.selectors.existingEmailAccountInfoClass).html(infoText).show();
  },
  
  
  /**
  * When a different country is selected, we need to update the remote Checkout object
  * with this country to receive the correct currency
  */
  countrySelectionChanged: function(event) {
    // update the Checkout object on the remote server
    FN.storeHelpers.toggleLoadingOverlay(true);
    FN.store.updateRemoteCheckout(FN.storeHelpers.config.actions.changeCountry, event);
  },

  
  /**
  * When an email address was entered, we need to update the remote Checkout object
  * in order to check if this address already has an account / subscription
  */
  emailAddressChanged: function(event) {
    // update the Checkout object on the remote server
    FN.store.updateRemoteCheckout(FN.storeHelpers.config.actions.changeEmail, event);
  },


  /**
  * Finalize the remote checkout object for payment
  */
  finalizeRemoteCheckout: function() {
    $('#' + FN.store.config.selectors.submitButtonID).attr('disabled', 'disabled');
    
    FN.store.cart.couponCode      = $(FN.store.config.selectors.couponInput).val();
    FN.store.cart.upgradeLicense  = $(FN.store.config.selectors.upgradeInput).val();
    
    var requestURL        = FN.config.urls.checkoutApi;
    var requestData       = { 'action': FN.storeHelpers.config.actions.finalizeCheckout,
                              'checkout_uuid': FN.checkout.checkout_uuid,
                              'checkout_data': {},
                              'rewardful_referral': window.Rewardful && window.Rewardful.referral
                            };
    // add form data
    requestData['checkout_data']['quantity'] = FN.store.cart.quantity;
    var formData = $('#' + FN.store.config.selectors.formID).serializeArray();
    for(var i = 0; i < formData.length; i++) {
      requestData['checkout_data'][formData[i]['name']] = formData[i]['value'];
    }
    
    var requestOptions = {
      'responseContainer': $('.' + FN.store.config.selectors.validationContainerClass),
      'onComplete': FN.store.handleFinalizeCheckoutResponse
    };
    
    FN.remoteRequest.sendRequest(requestURL, requestData, requestOptions);
  },
  
  
  /**
  * Handle response for finalize checkout calls
  */
  handleFinalizeCheckoutResponse: function(xhr, options) {
    $(options.responseContainer).add(options.responseIndicator).removeClass('success loading');
    $('#' + FN.store.config.selectors.submitButtonID).prop('disabled', false);
    $(FN.store.config.selectors.quantityInput).attr('readonly', 'readonly');

    var responseData = (xhr.responseJSON && ('data' in xhr.responseJSON)) ? xhr.responseJSON.data : false;
    // the proxy always answers 200; Licensing's status is in the body
    var responseStatus = (xhr.responseJSON && ('status' in xhr.responseJSON)) ? xhr.responseJSON.status : xhr.status;
    if(responseStatus === 200 && ('checkout_url' in responseData)) {
      FN.checkout = responseData;
      $(options.responseContainer).html('');
      // open Paddle.js payment overlay
      Paddle.Checkout.open({ 
        override: FN.checkout.checkout_url,
        successCallback: function(data) {
          FN.storeHelpers.paymentWasSuccessful(data);
        },
        closeCallback: function(data) {
          FN.storeHelpers.paymentWasCancelled(data);
        }
      });

      return true;
      
    }else if(responseStatus === 422){
      // the sales offer this checkout was priced with has ended (beyond its grace period):
      // reload, which creates a fresh checkout at the current price
      if(responseData.name === FN.store.config.errorConstants.finalizeSalesDiscountExpired){
        $('#' + FN.store.config.selectors.submitButtonID).attr('disabled', 'disabled');
        $(options.responseContainer).add(options.responseIndicator).addClass(FN.store.config.cartStatus.loading);
        $(options.responseContainer).html('<p>' + FN.store.config.messages.salesDiscountExpired + '</p>');
        setTimeout(function(){ window.location.reload(); }, 2500);
        return false;
      }

      // coupon was already redeemed -or- upgrade license was already upgraded
      var userMessage = '';
      if(responseData.name === FN.store.config.errorConstants.finalizeCouponAlreadyRedeemed) userMessage += '<p>' + FN.store.config.messages.couponAlreadyRedeemed + '</p>';
      if(responseData.name === FN.store.config.errorConstants.finalizeCouponExpired) userMessage += '<p>' + FN.store.config.messages.couponExpired + '</p>';
      if(responseData.name === FN.store.config.errorConstants.finalizeUpgradeLicenseAlreadyUpgraded) userMessage += '<p>' + FN.store.config.messages.upgradeLicenseAlreadyUpgraded + '</p>';
      if(userMessage === '') userMessage += FN.store.config.messages.generalErrorOccured;
      
      $(options.responseContainer).add(options.responseIndicator).addClass(FN.store.config.cartStatus.error);
      $(options.responseContainer).html(userMessage);
      return false;
      
    }else{
      // a general error
      $(options.responseContainer).add(options.responseIndicator).addClass(FN.store.config.cartStatus.error);
      $(options.responseContainer).html(FN.store.config.messages.generalErrorOccured);
      return false;
    }
  },
  
  
  /**
  * Update the remote checkout object, e.g. with a coupon code OR an upgrade license key OR other additional user input
  */
  updateRemoteCheckout: function(action, event) {
    var responseContainer = false, 
        responseIndicator = false;
    var requestData = { 'action': action, 'checkout_uuid': FN.checkout.checkout_uuid };
        
    if(action === FN.storeHelpers.config.actions.setCoupon){
      // coupon code
      containerClass = FN.store.config.selectors.couponContainerClass;
      requestData['coupon_code'] = $(FN.store.config.selectors.couponInput).val();
      responseContainer = $('.' + containerClass).find('.discounts__request-notice');
      responseIndicator = $('.' + containerClass).find('.discounts__checker');
      
    }else if(action === FN.storeHelpers.config.actions.setUpgradeLicense){
      // upgrade license
      containerClass = FN.store.config.selectors.upgradeContainerClass;
      requestData['upgrade_license'] = $(FN.store.config.selectors.upgradeInput).val();
      responseContainer = $('.' + containerClass).find('.discounts__request-notice');
      responseIndicator = $('.' + containerClass).find('.discounts__checker');
      
    }else if( action === FN.storeHelpers.config.actions.changeCountry ||
              action === FN.storeHelpers.config.actions.changeEmail ||
              action === FN.storeHelpers.config.actions.updateCheckout){
      // update checkout with various additional user input, e.g. email
      requestData['checkout_data'] = { 'quantity': FN.store.cart.quantity };
      var formData = $('#' + FN.store.config.selectors.formID).serializeArray();
      for(var i = 0; i < formData.length; i++) {
        requestData['checkout_data'][formData[i]['name']] = formData[i]['value'];
      }
    }

    var requestURL = FN.config.urls.checkoutApi;
    var requestOptions = {
      'action': action,
      'responseContainer': responseContainer,
      'responseIndicator': responseIndicator,
      'onComplete': FN.store.handleUpdateCheckoutResponse
    };
    
    if(responseContainer) responseContainer.addClass(FN.store.config.cartStatus.loading);
    FN.remoteRequest.sendRequest(requestURL, requestData, requestOptions);
  },
  
  
  /**
  * Handle response for update checkout request
  */
  handleUpdateCheckoutResponse: function(xhr, options) {
    var displayStatus = { 'status': false, 'message': false };
    
    if(xhr.status !== 200) {
      // request error
      $(options.responseContainer).add(options.responseIndicator).removeClass('success loading').addClass('error');
      $(options.responseContainer).html(FN.store.config.messages.generalErrorOccured);
      return;
    }
    
    // update checkout object from licensing system
    FN.checkout = xhr.responseJSON.data;
    
    if(options.action === FN.storeHelpers.config.actions.setCoupon){
      // -------------- set coupon code
      if(typeof FN.checkout.coupon === 'undefined') {
        // no coupon code attached to this checkout
        FN.store.cart.couponCode = false;
        displayStatus = { 'status': FN.store.config.cartStatus.success, 'message': FN.store.config.messages.couponRemoved };
      
      }else if(FN.checkout.coupon.applicable == true){
        // coupon code successfully attached to this checkout
        FN.store.cart.couponCode = FN.checkout.coupon.code;
        displayStatus = { 'status': FN.store.config.cartStatus.success, 'message': FN.store.config.messages.couponSuccessfullyApplied };
        
      }else if(FN.checkout.coupon.applicable == false){
        // coupon code could not be attached to this checkout
        FN.store.cart.couponCode = false;
        displayStatus.status = FN.store.config.cartStatus.error;
        if(FN.checkout.coupon['non_applicable_reason'] === FN.store.config.errorConstants['couponNotFound']){
          displayStatus.message = FN.store.config.messages.couponNotFound;
        }else if(FN.checkout.coupon['non_applicable_reason'] ===  FN.store.config.errorConstants['couponAlreadyRedeemed']){
          displayStatus.message = FN.store.config.messages.couponAlreadyRedeemed;
        }else if(FN.checkout.coupon['non_applicable_reason'] ===  FN.store.config.errorConstants['couponExpired']){
          displayStatus.message = FN.store.config.messages.couponExpired;
        }else if(FN.checkout.coupon['non_applicable_reason'] ===  FN.store.config.errorConstants['couponNotApplicable']){
          displayStatus.message = FN.store.config.messages.couponNotApplicable;
        }
      }

    }else if(options.action === FN.storeHelpers.config.actions.setUpgradeLicense){
      // -------------- set upgrade license key
      if(typeof FN.checkout.upgrade_license === 'undefined') {
        // no upgrade license attached to this checkout
        FN.store.cart.upgradeLicense = false;
        displayStatus = { 'status': FN.store.config.cartStatus.success, 'message': FN.store.config.messages.upgradeLicenseRemoved };
        
      }else if(FN.checkout.upgrade_license.applicable == true){
        // upgrade license successfully attached to this checkout
        FN.store.cart.upgradeLicense = FN.checkout.upgrade_license.license_code;
        displayStatus.status = FN.store.config.cartStatus.success;
        if('grace_period' in FN.checkout.upgrade_license && FN.checkout.upgrade_license.grace_period === true){
          displayStatus.message = FN.checkout.upgrade_license.grace_period_seats + ((FN.checkout.upgrade_license.grace_period_seats === 1) ? ' seat ' : ' seats ') + FN.store.config.messages.upgradeLicenseGracePeriod;
          $(FN.store.config.selectors.quantityInput).val(FN.checkout.upgrade_license.grace_period_seats);
          FN.store.updateQuantity();
        }else{
          displayStatus.message = FN.store.config.messages.upgradeLicenseSuccessfullyApplied;
        }
        
      }else if(FN.checkout.upgrade_license.applicable == false){
        // upgrade license could not be attached to this checkout
        FN.store.cart.upgradeLicense = false;
        displayStatus.status = FN.store.config.cartStatus.error;
        if(FN.checkout.upgrade_license['non_applicable_reason'] === FN.store.config.errorConstants['upgradeLicenseNotFound']){
          displayStatus.message = FN.store.config.messages.upgradeLicenseNotFound;
        }else if(FN.checkout.upgrade_license['non_applicable_reason'] === FN.store.config.errorConstants['upgradeLicenseAlreadyUpgraded']){
          displayStatus.message = FN.store.config.messages.upgradeLicenseAlreadyUpgraded;
        }else if(FN.checkout.upgrade_license['non_applicable_reason'] === FN.store.config.errorConstants['upgradeLicenseNotApplicable']){
          if(FN.checkout.upgrade_license['license_code'].substring(0, 4) === "TOWR"){
            // entered license key is already a NEW key that cannot + does not have to be upgraded
            displayStatus.message = FN.store.config.messages.upgradeLicenseNotNecessary;
          }else{
            displayStatus.message = FN.store.config.messages.upgradeLicenseNotApplicable;
          }
        }
      }
      
    }else if(options.action === FN.storeHelpers.config.actions.changeCountry){
      // -------------- change country selection
      FN.storeHelpers.toggleLoadingOverlay(false);
      var topPosition = $('#' + FN.store.config.selectors.formID).offset().top - 50;
      $('html, body').animate({ scrollTop: topPosition + 'px' });
      
    }else if(options.action === FN.storeHelpers.config.actions.changeEmail || 
             options.action === FN.storeHelpers.config.actions.updateCheckout){
      // -------------- add / update various user input, e.g. email
      if('account' in FN.checkout){
        FN.store.showExistingAccountNotice();
      }
    }
    
    if(typeof options.responseContainer !== 'undefined'){
      $(options.responseContainer).removeClass('error success loading').addClass(displayStatus.status);
      $(options.responseContainer).html(displayStatus.message);
    }
    if(typeof options.responseIndicator !== 'undefined'){
      $(options.responseIndicator).removeClass('error success loading').addClass(displayStatus.status);
    }
    
    FN.store.updateDisplayedPricing();
    FN.store.updateDisplayedMonthlyPricing();
    FN.store.updateDisplayedUserSentence();
    FN.store.determineRequiredFields();
    FN.storeHelpers.moveField(FN.store.config.selectors.billingFieldZip, null);
  },
    
  
  /**
  * Init quantity
  */
  initQuantity: function(){
    FN.store.cart.quantity = FN.checkout.quantity;
    FN.store.cart.maxQuantity = $('.' + FN.store.config.selectors.seatsContainerClass).data('max-quantity');
    FN.store.cart.minQuantity = $('.' + FN.store.config.selectors.seatsContainerClass).data('min-quantity');
        
    // Show only one type of quantity container (--> show immutable string if max_quantity == min_quantity)
    var immutableQuantityContainer = $('.'+ FN.store.config.selectors.quantityContainerClass + '--immutable');
    var mutableQuantityContainer  = $('.'+ FN.store.config.selectors.quantityContainerClass + '--mutable');

    if(FN.storeHelpers.isQuantityFixed()){
      $(immutableQuantityContainer).show();
      $(mutableQuantityContainer).hide();
    }else{
      $(immutableQuantityContainer).hide();
      $(mutableQuantityContainer).show();
    }
  },
  
  
  /**
  * Init the coupon field, if either a coupon was provided via URL or via an existing checkout object
  */
  initCouponField: function(){
    if(!FN.checkout.coupon || !FN.checkout.coupon.code) return;
    
    FN.store.cart.couponCode = FN.checkout.coupon.code;
    
    $('.'+FN.store.config.selectors.couponContainerClass).show();
    $(FN.store.config.selectors.couponInput).val(FN.store.cart.couponCode);
  },
  
  
  /**
  * Init the upgrade license field, if either a key was provided via URL or via an existing checkout object
  */
  initUpgradeField: function(){
    if(!FN.checkout.upgrade_license || !FN.checkout.upgrade_license.license_code) return;

    FN.store.cart.upgradeLicense = FN.checkout.upgrade_license.license_code;
    
    $('.'+FN.store.config.selectors.upgradeContainerClass).show();
    $(FN.store.config.selectors.upgradeInput).val(FN.store.cart.upgradeLicense);
  },
  
  
  /**
  * Init the country selectbox
  */
  initCountrySelection: function() {
    if(!'country' in FN.checkout || !FN.checkout.country) return;

    $(FN.store.config.selectors.billingFieldCountry + ' option').each(function(i, option){
      var optionValue = $(this).attr('value');
      if(optionValue === FN.checkout.country){
        $(FN.store.config.selectors.billingFieldCountry).val(optionValue);
        return false;
      }
    });
    
    FN.store.determineRequiredFields();
    FN.storeHelpers.moveField(FN.store.config.selectors.billingFieldZip, null);
  },
  
  
  /**
  * Init the event handlers
  */
  initEventHandlers: function() {
    // event handling -- quantity change
    $('.'+FN.store.config.selectors.quantityStepperUpClass).on('click', function(event){ FN.store.changeQuantity(1); });
    $('.'+FN.store.config.selectors.quantityStepperDownClass).on('click', function(event){ FN.store.changeQuantity(-1); });
    $(FN.store.config.selectors.quantityInput).on('keyup', function(event){
  		if(event.keyCode == 38){ 		// up arrow key
  			FN.store.changeQuantity(1);
  		}else if(event.keyCode == 40){ 	// down arrow key
  			FN.store.changeQuantity(-1);
  		}
    });
    $(FN.store.config.selectors.quantityInput).on('change', function(event){
      FN.store.updateQuantity();
    });
    
    // event handling -- proceed to payment
    $('#' + FN.store.config.selectors.formID).on('submit', function(event){
      // in case of a regular form submission...
      event.preventDefault();
      if (FN.store.isEnterpriseForm()) { FN.store.proceedToEnterprisePayment(); } else { FN.store.proceedToPayment(); }
    });
    $('#' + FN.store.config.selectors.submitButtonID).on('click', function(event){
      event.preventDefault();
      if (FN.store.isEnterpriseForm()) { FN.store.proceedToEnterprisePayment(); } else { FN.store.proceedToPayment(); }
    });

    // event handling -- remote requests for coupon & upgrade license 
    $('.' + FN.store.config.selectors.couponContainerClass).find('.button').on('click', function(event){
      event.preventDefault();
      FN.store.updateRemoteCheckout(FN.storeHelpers.config.actions.setCoupon, event);
    });
    $('.' + FN.store.config.selectors.upgradeContainerClass).find('.button').on('click', function(event){
      event.preventDefault();
      FN.store.updateRemoteCheckout(FN.storeHelpers.config.actions.setUpgradeLicense, event);
    });
    
    // event handling -- toggle hidden fields
    $('.'+FN.store.config.selectors.couponInputToggleClass).on('click', function(event){
      event.preventDefault();
      $('.'+FN.store.config.selectors.upgradeContainerClass).hide();
      $('.'+FN.store.config.selectors.couponContainerClass).toggle();
    });
    $('.'+FN.store.config.selectors.upgradeInputToggleClass).on('click', function(event){
      event.preventDefault();
      $('.'+FN.store.config.selectors.couponContainerClass).hide();
      $('.'+FN.store.config.selectors.upgradeContainerClass).toggle();
    });
    $('.'+FN.store.config.selectors.billingSecondaryToggleClass).on('click', function(event){
      event.preventDefault();
      $('.'+FN.store.config.selectors.billingSecondaryClass).toggle();
    });
    
    // event handling -- country selection
    $(FN.store.config.selectors.billingFieldCountry).on('change', function(event){
      FN.store.countrySelectionChanged(event);
    });
    
    // event handling -- check entered email address
    $(FN.store.config.selectors.billingFieldEmail).on('change', function(event){
      FN.store.emailAddressChanged(event);
    });

    // event handling -- check entered VAT number
    $(FN.store.config.selectors.billingFieldVat).on('change', function(event){
      FN.store.determineRequiredFields(event);
      FN.storeHelpers.toggleSecondaryFields(null);
    });
  },


  /**
  * Returns true when the current page uses the enterprise store form
  */
  isEnterpriseForm: function() {
    return $('#' + FN.store.config.selectors.formID).data('form-mode') === 'enterprise';
  },


  /**
  * Returns true when the invoice payment method is selected on the enterprise form
  */
  isInvoicePayment: function() {
    return $(FN.store.config.selectors.paymentMethodRadio + ':checked').val() === 'invoice';
  },


  /**
  * Initialise the enterprise payment method toggle (Card / Invoice)
  */
  initEnterpriseForm: function() {
    FN.store.onEnterprisePaymentMethodChange();
    $(FN.store.config.selectors.paymentMethodRadio).on('change', FN.store.onEnterprisePaymentMethodChange);
  },


  /**
  * React to a payment method selection change on the enterprise form
  */
  onEnterprisePaymentMethodChange: function() {
    var isInvoice    = FN.store.isInvoicePayment();
    var submitButton = $('#' + FN.store.config.selectors.submitButtonID);
    submitButton.val(isInvoice ? 'Request Invoice' : 'Proceed to Payment');
    $(FN.store.config.selectors.billingEmailField).toggle(isInvoice);
    FN.store.determineRequiredFieldsEnterprise();
  },


  /**
  * Determine required fields for the enterprise form (card vs invoice)
  */
  determineRequiredFieldsEnterprise: function() {
    var isInvoice = FN.store.isInvoicePayment();

    var requiredFields = [
      FN.store.config.selectors.billingFieldEmail,
      FN.store.config.selectors.billingFieldCountry,
      FN.store.config.selectors.billingFieldZip,
      FN.store.config.selectors.billingFieldName,
      FN.store.config.selectors.billingFieldCompany
    ];
    if (isInvoice) {
      requiredFields.push(FN.store.config.selectors.billingFieldAddress);
      requiredFields.push(FN.store.config.selectors.billingFieldCity);
    }

    FN.store.cart.requiredFields = requiredFields;
    FN.storeHelpers.highlightRequiredFields();
    return requiredFields;
  },


  /**
  * Entry point for the enterprise form submit — branches on card vs invoice
  */
  proceedToEnterprisePayment: function() {
    if (FN.store.isInvoicePayment()) {
      FN.store.submitEnterpriseInvoiceCheckout();
    } else {
      // name and company are always required for enterprise card; everything else
      // is already covered by the existing proceedToPayment() / validateCart() flow
      var extraErrors = [];
      if (!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldName).val()) {
        extraErrors.push({ 'message': 'Please enter your name.',
                           'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldName) });
      }
      if (!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldCompany).val()) {
        extraErrors.push({ 'message': 'Please enter your company name.',
                           'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldCompany) });
      }
      if (isNaN(FN.store.cart.quantity) || FN.store.cart.quantity < 10) {
        extraErrors.push({ 'message': 'Enterprise plans require a minimum of 10 seats.',
                           'fieldSelector': FN.store.config.selectors.quantityInput });
      }
      if (extraErrors.length > 0) {
        FN.storeHelpers.displayCartStatus({ 'status': FN.store.config.cartStatus.error, 'messages': extraErrors });
        return false;
      }
      FN.store.proceedToPayment();
    }
  },


  /**
  * Validate all required fields for the enterprise invoice path
  */
  validateEnterpriseInvoice: function() {
    var cartStatus = { 'status': false, 'messages': [] };

    // validate standard billing fields via the shared helper
    var fieldsToValidate = [
      FN.store.config.selectors.billingFieldEmail,
      FN.store.config.selectors.billingFieldCountry,
      FN.store.config.selectors.billingFieldZip,
      FN.store.config.selectors.billingFieldCompany,
      FN.store.config.selectors.billingFieldAddress,
      FN.store.config.selectors.billingFieldCity
    ];
    for (var i = 0; i < fieldsToValidate.length; i++) {
      var fieldError = FN.storeHelpers.validateField(fieldsToValidate[i]);
      if (fieldError) cartStatus.messages.push(fieldError);
    }

    // validate name (not in the shared validateField helper)
    if (!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldName).val()) {
      cartStatus.messages.push({ 'message': 'Please enter your name.',
                                 'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldName) });
    }

    // validate legal consent
    if (!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.consentFieldLegal).prop('checked')) {
      cartStatus.messages.push({ 'message': 'Please read and accept our Privacy Policy.',
                                 'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.consentFieldLegal) });
    }

    // validate marketing consent (must pick yes or no)
    if ($('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.consentFieldMarketing + ':checked').length !== 1) {
      cartStatus.messages.push({ 'message': 'Please tell us if you want to hear about news & updates.',
                                 'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.consentFieldMarketing) });
    }

    // validate quantity (minimum 10 for enterprise)
    if (isNaN(FN.store.cart.quantity) || FN.store.cart.quantity < 10) {
      cartStatus.messages.push({ 'message': 'Enterprise plans require a minimum of 10 seats.',
                                 'fieldSelector': FN.store.config.selectors.quantityInput });
    }

    cartStatus.status = (cartStatus.messages.length === 0) ? FN.store.config.cartStatus.success : FN.store.config.cartStatus.error;
    return cartStatus;
  },


  /**
  * POST the enterprise invoice checkout form to the Kirby API endpoint
  */
  submitEnterpriseInvoiceCheckout: function() {
    var cartStatus = FN.store.validateEnterpriseInvoice();
    if (cartStatus.status === FN.store.config.cartStatus.error) {
      FN.storeHelpers.displayCartStatus(cartStatus);
      return false;
    }

    var loadingStatus = { 'status': FN.store.config.cartStatus.loading, 'messages': [{ 'message': 'Submitting your request...' }] };
    FN.storeHelpers.displayCartStatus(loadingStatus);
    $('#' + FN.store.config.selectors.submitButtonID).attr('disabled', 'disabled');

    var requestData = { 'quantity': FN.store.cart.quantity };
    var formData    = $('#' + FN.store.config.selectors.formID).serializeArray();
    for (var i = 0; i < formData.length; i++) {
      requestData[formData[i]['name']] = formData[i]['value'];
    }

    var requestOptions = {
      'responseContainer': $('.' + FN.store.config.selectors.validationContainerClass),
      'onComplete': FN.store.handleEnterpriseInvoiceResponse
    };

    FN.remoteRequest.sendRequest(FN.config.urls.enterpriseInvoiceCheckoutApi, requestData, requestOptions);
  },


  /**
  * Handle the response from the enterprise invoice checkout endpoint
  */
  handleEnterpriseInvoiceResponse: function(xhr, options) {
    $('#' + FN.store.config.selectors.submitButtonID).prop('disabled', false);
    $(options.responseContainer).removeClass('success loading error');

    if (xhr.responseJSON && xhr.responseJSON.status === 201) {
      var email        = $('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldEmail).val();
      var emailEscaped = $('<span>').text(email).html();
      $('#' + FN.store.config.selectors.formID + ' section').hide();
      $('.enterprise-invoice-confirmation').show();
      $('html, body').animate({ scrollTop: $('.enterprise-invoice-confirmation').offset().top - 50 + 'px' });
      $('.enterprise-invoice-confirmation__message').html(
        'Thanks! We\'ve sent a confirmation email to <strong>' + emailEscaped + '</strong>. ' +
        'Please click the link in the email to activate your subscription.'
      );
    } else {
      $(options.responseContainer).addClass(FN.store.config.cartStatus.error);
      $(options.responseContainer).html(FN.store.config.messages.generalErrorOccured);
    }
  }
};




$(document).ready(function(){
  FN.store.init();
});
